/**
 * @copyright       Palace Resorts
 * @description     Mensajes generales de la aplicación.
 * @author          Roberto Pérez Guzmán
 * @creationDate    06 de Mayo del 2021
 */
export default {
  fallbackLocale: "ESP",
  locale: "ESP",
  messages: {
    ESP: {
      lblLoading: "Por favor espere, su solicitud está siendo atendida.",
      lblCancel: "Cancelar",
      lblOk: "Aceptar",
      lblSubmit: "Enviar",
      lblNext: "Continuar",
      lblBack: "Regresar",
      lblClose: "Cerrar",
      lblHelp: "Ayuda",
    },
    ENG: {
      lblLoading: "Please stand by, your request is being processed.",
      lblCancel: "Cancel",
      lblOk: "Ok",
      lblSubmit: "Submit",
      lblNext: "Next",
      lblBack: "Back",
      lblHelp: "Help",
    },
  },
};
